import "./ui.css"

/**
 * ErrorState - shown when data fails to load. Announced to screen readers (role="alert").
 *
 * Usage:
 *  <ErrorState message={error} onRetry={fetchPorts} />
 *
 * Props:
 *  - title: heading (default "Something went wrong")
 *  - message: error detail shown to the user
 *  - onRetry: when provided, renders a retry button that calls it
 *  - retryLabel: retry button text (default "Try again")
 *  - icon: icon class names (default "fe fe-alert-triangle")
 *  - compact: less vertical padding
 */
export default function ErrorState({
  title = "Something went wrong",
  message,
  onRetry,
  retryLabel = "Try again",
  icon = "fe fe-alert-triangle",
  compact = false,
  className = "",
}) {
  return (
    <div
      className={`vy-state vy-state--error ${compact ? "vy-state--compact" : ""} ${className}`.replace(/\s+/g, " ").trim()}
      role="alert"
    >
      {icon && (
        <span className="vy-state__icon" aria-hidden="true">
          <i className={icon} />
        </span>
      )}
      <p className="vy-state__title">{title}</p>
      {message && <p className="vy-state__description">{message}</p>}
      {onRetry && (
        <div className="vy-state__action">
          <button type="button" className="vy-btn vy-btn--secondary" onClick={onRetry}>
            {retryLabel}
          </button>
        </div>
      )}
    </div>
  )
}
